export enum FeedbackSourceType {
  MAIL = 'Mail',
  MEET = 'Meet',
  SMS = 'Sms',
}
